module.exports = __webpack_public_path__ + "img/906dab3.png";